<template>
  <div class="main-container">
    <div class="main-content-wrap">
      <div class="main-content-pannel">
        <option-menu class="no-bg no-border">
          <div class="content-title-wrap">
            <div class="main-content-title">Payroll</div>
            <div class="main-content-menu">
              <div class="date-range">
                <VueCtkDateTimePicker
                  id="start"
                  format="YYYY-MM-DD"
                  formatted="ll"
                  :range="true"
                  v-model="dateRange"
                >
                  <button type="button"></button>
                </VueCtkDateTimePicker>
              </div>
              <div class="searchbox">
                <label for="roleFilter">
                  <i
                    v-if="!filterTxt"
                    class="material-icons-outlined align-middle"
                    >search</i
                  >
                  <i
                    v-else
                    @click="onQuickFilterChanged"
                    class="material-icons-outlined align-middle"
                    >clear</i
                  >
                </label>
                <input
                  id="roleFilter"
                  type="text"
                  @keyup="onQuickFilterChanged"
                  :value="filterTxt"
                  placeholder="Search"
                />
              </div>
              <button
                class="btn primary"
                href="javascript:void(0);"
                @click="sendAll()"
              >
                <i class="material-icons-outlined align-middle">send</i>
                Send All
              </button>
            </div>
          </div>
        </option-menu>

        <div class="main-bg p-0 m-t-0 m-b-0">
          <ag-grid-vue
            style="width: 100%; height: calc(100vh - 230px)"
            class="ag-theme-material"
            :gridOptions="gridOptions"
            :columnDefs="columnDefs"
            @column-resized="onColumnResized"
            @first-data-rendered="onFirstDataRendered"
            @grid-size-changed="onFirstDataRendered"
            :rowData="rowData"
          ></ag-grid-vue>
        </div>
      </div>
    </div>
  </div>
</template>


<script>
import EditPannel from "@/components/EditPannel.vue";
import OptionMenu from "@/components/OptionMenu.vue";
import { db } from "@/vendor/firebase";
import { AgGridVue } from "ag-grid-vue";
import "ag-grid-enterprise";
import "@/assets/css/ag-grid.scss";

import { workHours } from "@/utils/utils";

import { httpGetFirebaseOnCall } from "@/http/http";
import GridActions from "@/components/admin/payroll/GridActions.vue";

import VueCtkDateTimePicker from "vue-ctk-date-time-picker";
import "vue-ctk-date-time-picker/dist/vue-ctk-date-time-picker.css";
import GridDropdownMenu from "@/components/admin/payroll/GridDropdownMenu";
import moment from "moment-timezone";

export default {
  data() {
    return {
      filterTxt: "",
      gridOptions: {},
      columnDefs: null,
      rowData: null,

      dateRange: null,
      jobs: null,
      consultants: null,
      dd: {
        index: null,
        el: null,
        isOpen: false,
      },
    };
  },
  watch: {
    dateRange() {
      this.updateRowData();
    },
    consultants() {
      this.updateRowData();
    },
    jobs() {
      this.updateRowData();
    },
  },
  beforeMount() {
    this.createColumnDefs();
    this.initData();
  },
  created: function () {
    this.$EventBus.$on("globalClick", (event) => {
      this.hideAgDropdown(event);
    });
    setTimeout(() => {
      this.enableSetLocal = true;
    }, 3000);
  },
  components: {
    EditPannel,
    OptionMenu,
    AgGridVue,
    GridActions,
    VueCtkDateTimePicker,
    GridDropdownMenu,
  },
  methods: {
    onQuickFilterChanged(event) {
      this.filterTxt = event.target.value;
      this.gridOptions.api.setQuickFilter(event.target.value);
    },
    onColumnResized(params) {
      params.api.resetRowHeights();
    },
    onFirstDataRendered(params) {
      params.api.sizeColumnsToFit();
    },
    createColumnDefs() {
      this.gridOptions = {
        defaultColDef: {
          enableRowGroup: true,
          enablePivot: true,
          sortable: true,
          resizable: true,
          filter: true,
          autoHeight: true,
        },
        context: {
          componentParent: this,
        },
        animateRows: true,
        sideBar: false,
        enableCellTextSelection: true,
        pagination: true,
        paginationPageSize: 9,
        paginationNumberFormatter: function (params) {
          return "[" + params.value.toLocaleString() + "]";
        },
      };
      this.columnDefs = [
        { headerName: "NAME", field: "name" },
        { headerName: "SLACK ID", field: "slackId" },
        { headerName: "HOURS", field: "hours" },
        { headerName: "TIMES", field: "times" },
        { headerName: "MONTH", field: "month" },
        { headerName: "EMAIL", field: "email" },
        { headerName: "RATE", field: "rate" },
        { headerName: "AMOUNT", field: "amount" },
        {
          headerName: "ACTIONS",
          field: "actions",
          width: 180,
          cellClass: "overflow-visible",
          cellRendererFramework: "GridDropdownMenu",
          sortable: false,
          filter: false,
          rowGroup: false,
        },
      ];
    },
    initDateRange() {
      const start = moment()
        .subtract(1, "month")
        .startOf("month")
        .format("YYYY-MM-DD");
      const end = moment()
        .subtract(1, "month")
        .endOf("month")
        .format("YYYY-MM-DD");
      this.dateRange = {
        start,
        end,
      };
    },
    initData() {
      this.initDateRange();
      this.$bind("consultants", db.collection("consultants"));
      this.$bind("jobs", db.collection("jobs"));
    },
    updateRowData() {
      if (
        this.dateRange &&
        this.dateRange.start &&
        this.dateRange.end &&
        this.consultants &&
        this.consultants.length > 0 &&
        this.jobs &&
        this.jobs.length > 0
      ) {
        this.rowData = [];
        const startTimestamp =
          moment.tz(this.dateRange.start, "America/Los_Angeles").valueOf() /
          1000;
        const endTimestamp =
          moment
            .tz(this.dateRange.end, "America/Los_Angeles")
            .endOf("day")
            .valueOf() / 1000;
        const startMonth = moment
          .tz(this.dateRange.start, "America/Los_Angeles")
          .format("MMMM");
        const endMonth = moment
          .tz(this.dateRange.end, "America/Los_Angeles")
          .endOf("day")
          .format("MMMM");
        const month = startMonth == endMonth ? startMonth : "";
        const emailToData = {};
        this.consultants.forEach((item) => {
          if (item.email) {
            emailToData[item.email] = item;
          }
        });
        const emailToRowData = {};
        this.jobs.forEach((item) => {
          if (
            item.check_in >= startTimestamp &&
            item.check_in <= endTimestamp
          ) {
            const hours = workHours(
              item.check_out - item.check_in,
              item.work_type
            );
            if (emailToRowData[item.consultant]) {
              emailToRowData[item.consultant].hours += hours;
              emailToRowData[item.consultant].times += 1;
              emailToRowData[item.consultant].amount +=
                hours * emailToRowData[item.consultant].rate;
              emailToRowData[item.consultant].ddOpen = false;
            } else {
              if (emailToData[item.consultant]) {
                const rate = emailToData[item.consultant].rate
                  ? isNaN(Number(emailToData[item.consultant].rate))
                    ? 0
                    : Number(emailToData[item.consultant].rate)
                  : 0;
                emailToRowData[item.consultant] = {
                  name: emailToData[item.consultant].name
                    ? emailToData[item.consultant].name
                    : "",
                  slackId: emailToData[item.consultant].slack_id
                    ? emailToData[item.consultant].slack_id
                    : "",
                  hours: hours,
                  times: 1,
                  month: month,
                  email: emailToData[item.consultant].email
                    ? emailToData[item.consultant].email
                    : "",
                  rate: rate,
                  amount: rate * hours,
                  startTime: startTimestamp,
                  endTime: endTimestamp,
                  ddOpen: false,
                };
              }
            }
          }
        });
        for (const i in emailToRowData) {
          this.rowData.push(emailToRowData[i]);
        }
        this.rowData.forEach((item, index) => {
          item.rowindex = index;
        });
      }
    },
    sendAll() {
      if (this.dateRange && this.dateRange.start && this.dateRange.end) {
        const startTimestamp =
          moment.tz(this.dateRange.start, "America/Los_Angeles").valueOf() /
          1000;
        const endTimestamp =
          moment
            .tz(this.dateRange.end, "America/Los_Angeles")
            .endOf("day")
            .valueOf() / 1000;
        this.send({ startTime: startTimestamp, endTime: endTimestamp });
      } else {
        this.$toasted.global.toast_error({ message: "invalid params" });
      }
    },
    sendSingle(data) {
      if (data && data.startTime && data.endTime && data.email) {
        this.send({
          startTime: data.startTime,
          endTime: data.endTime,
          consultants: [data.email],
        });
      } else {
        this.$toasted.global.toast_error({ message: "invalid params" });
      }
    },
    send(data) {
      httpGetFirebaseOnCall("sendPayrollEmail", data).then((response) => {
        if (response.ok) {
          this.$toasted.global.toast_success({ message: "send success" });
        } else {
          this.$toasted.global.toast_success({ message: "send success" });
          // this.$toasted.global.toast_error({ message: response.message });
        }
      });
    },
    openCurrentAgDropdown: function (item, el) {
      if (this.dd.isOpen) {
        this.$set(this.rowData[this.dd.index], "ddOpen", false);
      }
      this.dd.isOpen = item.ddOpen;
      this.dd.index = item.rowindex;
      this.dd.el = el;
    },
    hideAgDropdown: function (e) {
      if (this.dd.el && !this.dd.el.contains(e.target)) {
        this.hideCurrentAgDropdown();
      }
    },
    hideCurrentAgDropdown: function () {
      this.$set(this.rowData[this.dd.index], "ddOpen", false);
      this.dd.isOpen = false;
    },
  },
};
</script>
